/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EmailNotificationPreferencesPreferences } from './emailNotificationPreferencesPreferences';

/**
 * Channel-specific preferences for email notifications.
 */
export interface EmailNotificationPreferences {
  preferences?: EmailNotificationPreferencesPreferences;
}
